// The SurfaceApi context — provides the client TRANSPORT (fetch reads / route intents) to every Work surface
// without prop-drilling. The App root provides the REAL httpSurfaceApi; a UI test provides a fake that
// returns injected projections and records routed intents (hermetic — no real backend network in a UI test).
//
// Keeping the transport behind a context (not a hard import of `fetch`) is what makes the surfaces render
// from INJECTED projections in tests: the component asks the context for its data; the test decides what
// that data is. The dashboard performs no domain logic either way — it renders the projection and routes the
// intent to the owning Gate (P-GATE, thin-over-services).

import { createContext, useContext } from 'react';
import type { SurfaceApi } from './api-client.ts';

const SurfaceApiContext = createContext<SurfaceApi | null>(null);

export const SurfaceApiProvider = SurfaceApiContext.Provider;

/** Read the surface transport. Throws if used outside the provider (a wiring bug, surfaced honestly). */
export function useSurfaceApi(): SurfaceApi {
  const value = useContext(SurfaceApiContext);
  if (value === null) {
    throw new Error('useSurfaceApi must be used within the SurfaceApiProvider (App root or test)');
  }
  return value;
}
